import { IconContent } from '@icons';

export const lines: IconContent = {
    md: '<path d="M10 5.5a2 2 0 1 1 2.5 1.937V11.5H20v5.063a2 2 0 1 1-1 0V12.5h-6.5v4.063a2 2 0 1 1-1 0V12.5H5v4.063a2 2 0 1 1-1 0V11.5h7.5V7.437A2 2 0 0 1 10 5.5Z" />',
};
